import { Stack } from "@mui/material"
import { Mensaje } from "../../types";
import { MessageCardMobile } from "./MessageCardMobile";

export const MessageCardListMobile = ({ messages }: { messages: Mensaje[] }) => {

    return (
        <Stack spacing={2}>
            {
                messages.map((message, index) => (
                    <MessageCardMobile key={index} message={message} />
                ))
            }
        </Stack>
    )
}
